import * as React from "react"
import { cn } from "@/lib/utils"

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "secondary" | "destructive" | "outline"
}

function Badge({
  className,
  variant = "default",
  ...props
}: BadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-950 focus:ring-offset-2",
        {
          "border-transparent bg-emerald-600 text-white": variant === "default",
          "border-transparent bg-emerald-100 text-emerald-900": variant === "secondary",
          "border-transparent bg-red-500 text-white": variant === "destructive",
          "border-emerald-200 bg-transparent text-emerald-900": variant === "outline",
        },
        className
      )}
      {...props}
    />
  )
}

export { Badge }
